<template>
    <div style="height: 100%;width: 100%">
      <div style="margin: 10px 10px;height: calc(100% - 30px);overflow-y: hidden">
        <el-table
          class="handle-list"
          :header-cell-style="getBackgroundColor"
          :row-class-name="tableRowClassName"
          :cellStyle="cellStyle"
          :data="tableData"
          style="width: 100%"
          size="mini">
          <el-table-column
            label="编号"
            min-width="50"
            :resizable="true"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <marquee scrollamount="3">{{scope.row.id}}</marquee>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            min-width="55"
            :resizable="true"
            align="center">
          </el-table-column>
          <el-table-column
            label="处理人员"
            min-width="70"
            :resizable="true"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.p_name === '-'">{{scope.row.p_name}}</span>
              <marquee scrollamount="3" v-else>{{scope.row.p_name}}</marquee>
            </template>
          </el-table-column>
          <el-table-column
            label="开始处理时间"
            min-width="90"
            :resizable="true"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.handletime === '-'">{{scope.row.handletime}}</span>
              <marquee scrollamount="3" v-else>{{scope.row.handletime}}</marquee>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
</template>

<script>
export default {
  name: 'indexHandleList',
  props: {
    topObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      listData: [],
      tableData: [
        {id: '', status: '所有报警', p_name: '处理完成', handletime: ''}
      ]
    }
  },
  created () {
    // 处理列表
    this.golobleObject.getHandleInfo = this.changeShow
    this.listData = this.topObj.dataviewalarms.slice(0, 5)
    // console.log(this.listData)
    this.getAlarmData()
  },
  mounted () {
  },
  methods: {
    getListData (arr) {
      this.listData = arr.slice(0, 5)
      this.getAlarmData()
    },
    getAlarmData () {
      if (this.listData.length > 0) {
        this.tableData = []
        for (let i = 0; i < this.listData.length; i++) {
          this.listData[i].status = '待处理'
          this.listData[i].p_name = '-'
          this.listData[i].handletime = '-'
        }
        this.changeShow()
      } else {
        this.tableData = [{id: '', status: '所有报警', p_name: '处理完成', handletime: ''}]
      }
    },
    changeShow () {
      const handle = this.store2.state.other.isHandle
      // console.log('列表', handle)
      let idList = []
      for (let i = 0; i < handle.length; i++) {
        const obj = handle[i]
        idList.push(parseInt(obj.id))
      }
      this.tableData = []
      for (let i = 0; i < this.listData.length; i++) {
        const alarmObj = this.listData[i]
        if (idList.indexOf(alarmObj.id) > -1) {
          for (let ii = 0; ii < handle.length; ii++) {
            const usernameObj = handle[ii]
            if (usernameObj.id === alarmObj.id) {
              alarmObj.status = '处理中'
              alarmObj.p_name = usernameObj.name
              alarmObj.handletime = usernameObj.time
            }
          }
        }
        this.tableData.push(alarmObj)
      }
    },
    cellStyle ({row, column, rowIndex, columnIndex}) {
      return 'border-color:#1a1a1a!important;font-weight:bold!important'
    },
    getBackgroundColor () {
      return {backgroundColor: '#13213a', color: '#00ffff', borderColor: '#1a1a1a'}
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    }
  }
}
</script>
<style>
  .el-table .warning-row {
    background: #051230;
    color: #e6e6e6;
  }

  .el-table .success-row {
    background: #111a32;
    color: #e6e6e6;
  }
  .el-table tbody tr:hover>td {
    background-color:#ecf5ff00!important
  }
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexHandleList.vue